window.initClientExternalLinkForm = function() {
  $(".js-link-for").on('change', function(){
    $('[data-for]').addClass('is-hidden');
    $(`[data-for="${$(this).val()}"]`).removeClass('is-hidden');
  })
}
